// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-me-container-prof {
  width: 100%;
  display: flex;
  height: 700px;
  align-items: center;
  border-bottom: 1px rgba(0, 0, 0, 0.2) solid; }

.about-me-text-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0px 90px;
  font-size: 20pt; }
  .about-me-text-container > h2 {
    margin-top: 90px;
    font-weight: 300;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 1.5em;
    padding: 1.5em;
    padding-left: 0px;
    border-bottom: 1px rgba(0, 0, 0, 0.5) solid; }
  .about-me-text-container > button {
    margin-bottom: 40px;
    width: -moz-fit-content;
    width: fit-content;
    background-color: transparent;
    border: 0;
    color: #797979;
    text-decoration: underline;
    font-size: 15pt; }
    .about-me-text-container > button:hover {
      cursor: pointer;
      color: black; }
  .about-me-text-container > p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    line-height: 1.65;
    margin-bottom: 90px; }

.profile-pic {
  height: 360px;
  width: 360px;
  border-radius: 100%;
  border: 2px rgba(0, 0, 0, 0.3) dotted;
  padding: 5px;
  margin-right: 50px; }

.proj-container {
  padding-top: 50px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px rgba(0, 0, 0, 0.2) solid;
  padding-bottom: 70px; }
  .proj-container > h2 {
    font-weight: 300;
    width: -moz-fit-content;
    width: fit-content;
    font-size: 2em;
    padding: 20px;
    padding-top: 0px;
    margin-top: 0;
    margin-bottom: 80px;
    border-bottom: 1px rgba(0, 0, 0, 0.5) solid; }

.proj-desc {
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center; }
  .proj-desc > div {
    width: -moz-fit-content;
    width: fit-content;
    border: 1px rgba(0, 0, 0, 0.2) solid;
    border-radius: 100%;
    margin-bottom: 20px; }
    .proj-desc > div > img {
      width: 130px;
      height: 130px;
      padding: 50px; }
  .proj-desc > h2 {
    font-weight: 300;
    font-size: 20pt; }
  .proj-desc > p {
    height: 99px;
    text-align: center;
    font-size: 15pt;
    line-height: 1.65; }
  .proj-desc > img {
    width: 350px;
    border-radius: 15px;
    margin-bottom: 40px; }
  .proj-desc > button {
    width: 300px;
    height: 50px;
    border: 1px black solid;
    border-radius: 5px;
    background-color: transparent;
    margin-bottom: 20px;
    transition: background-color .2s; }
    .proj-desc > button:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.1); }
    .proj-desc > button:active {
      background-color: rgba(0, 0, 0, 0.4); }

.skills-container {
  width: 100%;
  height: 500px;
  border-bottom: 1px rgba(0, 0, 0, 0.2) solid; }

.contact-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px; }
  .contact-container > h2 {
    font-size: 2em;
    font-weight: 300;
    padding: 20px;
    border-bottom: 1px black solid; }
  .contact-container > div {
    width: 55%;
    display: flex;
    justify-content: space-around; }
    .contact-container > div > button {
      width: 200px;
      height: 60px;
      border: 1px black solid;
      border-radius: 15px;
      background-color: transparent;
      transition: background-color .2s; }
      .contact-container > div > button > img {
        width: 40px; }
      .contact-container > div > button:hover {
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.1); }
`, "",{"version":3,"sources":["webpack://./src/components/Professional/PageParts/PageParts.scss"],"names":[],"mappings":"AACA;EACI,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2CAA0D,EAAA;;AAe9D;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe,EAAA;EANnB;IAaQ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,2CAA0D,EAAA;EAnBlE;IAuBQ,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,cAAc;IACd,0BAA0B;IAC1B,eAAe,EAAA;IA7BvB;MAgCY,eAAe;MACf,YAAY,EAAA;EAjCxB;IAsCQ,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;IAEtB,iBAAiB;IAEjB,mBAAmB,EAAA;;AAI3B;EACI,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qCAAoD;EACpD,YAAY;EACZ,kBAAkB,EAAA;;AAWtB;EACI,iBAAiB;EACjB,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA0D;EAC1D,oBAAoB,EAAA;EARxB;IAWQ,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,2CAA0D,EAAA;;AAalE;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAA;EAJvB;IAOQ,uBAAkB;IAAlB,kBAAkB;IAClB,oCAAmD;IACnD,mBAAmB;IACnB,mBAAmB,EAAA;IAV3B;MAaY,YAAY;MACZ,aAAa;MACb,aAAa,EAAA;EAfzB;IAoBQ,gBAAgB;IAChB,eAAe,EAAA;EArBvB;IAyBQ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB,EAAA;EA5BzB;IAgCQ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB,EAAA;EAlC3B;IAsCQ,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAE7B,mBAAmB;IACnB,gCAAgC,EAAA;IA7CxC;MAgDY,eAAe;MACf,oCAAsC,EAAA;IAjDlD;MAqDY,oCAAsC,EAAA;;AAOlD;EACI,WAAW;EACX,aAAa;EACb,2CAA0D,EAAA;;AAK9D;EACI,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB,EAAA;EALzB;IAQQ,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,8BAA8B,EAAA;EAXtC;IAeQ,UAAU;IACV,aAAa;IACb,6BAA6B,EAAA;IAjBrC;MAoBY,YAAY;MACZ,YAAY;MACZ,uBAAuB;MACvB,mBAAmB;MACnB,6BAA6B;MAC7B,gCAAgC,EAAA;MAzB5C;QA4BgB,WAAW,EAAA;MA5B3B;QAgCgB,eAAe;QACf,oCAAsC,EAAA","sourcesContent":["// ↓↓↓ About me\n.about-me-container-prof {\n    width: 100%;\n    display: flex;\n    height: 700px;\n    align-items: center;\n    border-bottom: 1px rgba($color: #000000, $alpha: .2) solid;\n\n    // @media screen and (max-width: 1400px) {\n    //     flex-direction: column-reverse;\n    //     // margin-top: 325px;\n\n    //     &>.profile-pic {\n    //         position: absolute;\n    //         top: 0;\n    //         margin-top: 100px;\n    //         margin-right: 0px;\n    //     }\n    // }\n}\n\n.about-me-text-container {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    padding: 0px 90px;\n    font-size: 20pt;\n\n    // @media screen and (max-width: 1450px) {\n    //     align-items: center;\n    // }\n\n    &>h2 {\n        margin-top: 90px;\n        font-weight: 300;\n        width: fit-content;\n        font-size: 1.5em;\n        padding: 1.5em;\n        padding-left: 0px;\n        border-bottom: 1px rgba($color: #000000, $alpha: .5) solid;\n    }\n\n    &>button {\n        margin-bottom: 40px;\n        width: fit-content;\n        background-color: transparent;\n        border: 0;\n        color: #797979;\n        text-decoration: underline;\n        font-size: 15pt;\n\n        &:hover {\n            cursor: pointer;\n            color: black;\n        }\n    }\n\n    &>p {\n        display: block;\n        margin-block-start: 1em;\n        margin-block-end: 1em;\n        margin-inline-start: 0px;\n        margin-inline-end: 0px;\n        // font-size: .8em;\n        line-height: 1.65;\n        // line-height: 1.65;\n        margin-bottom: 90px;\n    }\n}\n\n.profile-pic {\n    height: 360px;\n    width: 360px;\n    border-radius: 100%;\n    border: 2px rgba($color: #000000, $alpha: .3) dotted;\n    padding: 5px;\n    margin-right: 50px;\n\n    // @media screen and (max-width: 500px) {\n    //     width: 200px;\n    //     height: 200px;\n    // }\n}\n\n// ↑↑↑ ABOUT ME\n\n// ↓↓↓ PROJECTS ↓↓↓\n.proj-container {\n    padding-top: 50px;\n    width: 100%;\n    height: fit-content;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-bottom: 1px rgba($color: #000000, $alpha: .2) solid;\n    padding-bottom: 70px;\n\n    &>h2 {\n        font-weight: 300;\n        width: fit-content;\n        font-size: 2em;\n        padding: 20px;\n        padding-top: 0px;\n        margin-top: 0;\n        margin-bottom: 80px;\n        border-bottom: 1px rgba($color: #000000, $alpha: .5) solid;\n    }\n\n    // @media screen and (max-width: 1160px) {\n    //     justify-content: center;\n\n    //     &>div {\n    //         flex-direction: column;\n    //         align-items: center;\n    //     }\n    // }\n}\n\n.proj-desc {\n    width: 400px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &>div {\n        width: fit-content;\n        border: 1px rgba($color: #000000, $alpha: .2) solid;\n        border-radius: 100%;\n        margin-bottom: 20px;\n\n        &>img {\n            width: 130px;\n            height: 130px;\n            padding: 50px;\n        }\n    }\n\n    &>h2 {\n        font-weight: 300;\n        font-size: 20pt;\n    }\n\n    &>p {\n        height: 99px;\n        text-align: center;\n        font-size: 15pt;\n        line-height: 1.65;\n    }\n\n    &>img {\n        width: 350px;\n        border-radius: 15px;\n        margin-bottom: 40px;\n    }\n\n    &>button {\n        width: 300px;\n        height: 50px;\n        border: 1px black solid;\n        border-radius: 5px;\n        background-color: transparent;\n        // padding: 10px 20px;\n        margin-bottom: 20px;\n        transition: background-color .2s;\n\n        &:hover {\n            cursor: pointer;\n            background-color: rgba($color: #000000, $alpha: .1);\n        }\n\n        &:active {\n            background-color: rgba($color: #000000, $alpha: .4);\n        }\n    }\n}\n\n// ↑↑↑ PROJECTS ↑↑↑\n// ↓↓↓ SKILLS ↓↓↓\n.skills-container {\n    width: 100%;\n    height: 500px;\n    border-bottom: 1px rgba($color: #000000, $alpha: .2) solid;\n}\n\n// ↑↑↑ SKILLS ↑↑↑\n// ↓↓↓ Contacts ↓↓↓\n.contact-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: 100px;\n\n    &>h2 {\n        font-size: 2em;\n        font-weight: 300;\n        padding: 20px;\n        border-bottom: 1px black solid;\n    }\n\n    &>div {\n        width: 55%;\n        display: flex;\n        justify-content: space-around;\n\n        &>button {\n            width: 200px;\n            height: 60px;\n            border: 1px black solid;\n            border-radius: 15px;\n            background-color: transparent;\n            transition: background-color .2s;\n\n            &>img {\n                width: 40px;\n            }\n\n            &:hover {\n                cursor: pointer;\n                background-color: rgba($color: #000000, $alpha: .1);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
